const fingoStepsData = {
  stackText: '¿CÓMO FUNCIONA?',
  titleText: 'Obtén tu dinero en tiempo récord',
  subtitleText: 'Sigue estos pasos en nuestra plataforma.',
  chileStepsInfo: [
    {
      id: 0,
      stepTitle: 'Regístrate y vincula tu cuenta del SII',
      imageTitle: 'Vincula la cuenta SII de tu empresa',
      description: 'Para ver tus facturas disponibles',
      image: '/images/step1.webp',
    },
    {
      id: 1,
      stepTitle: 'Selecciona tus documentos a anticipar y envía a evaluar',
      imageTitle: 'Envía tus facturas a evaluación',
      description: 'Nuestro equipo de riesgo revisará tu solicitud y te notificará para continuar',
      image: '/images/step2.webp',
    },
    {
      id: 2,
      stepTitle: 'Al revisar y aprobar tu solicitud, recibe tu dinero en pocas horas',
      imageTitle: 'Obtén tu dinero',
      description: 'Al recibir tu aprobación, confirma el anticipo y recibe tu dinero en pocas horas',
      image: '/images/step3.webp',
    },
  ],
  mexicoStepsInfo: [
    {
      id: 0,
      stepTitle: 'Regístrate y vincula tu cuenta del SAT',
      imageTitle: 'Vincula la cuenta SAT de tu empresa',
      description: 'Para ver tus facturas disponibles',
      image: '/images/step1.webp',
    },
    {
      id: 1,
      stepTitle: 'Envía documentos, completa y firma el formulario buró para obtener línea de crédito',
      imageTitle: 'Obtén tu línea de crédito',
      description: 'Quedarás habilitado para anticipar tus facturas',
      image: '/images/step-1.2-mx.webp',
    },
    {
      id: 2,
      stepTitle: 'Selecciona tus documentos a anticipar y envía a evaluar',
      imageTitle: 'Envía tus facturas a evaluación',
      description: 'Nuestro equipo de riesgo revisará tu solicitud y te notificará para continuar',
      image: '/images/step2.webp',
    },
    {
      id: 3,
      stepTitle: 'Al aprobar tu solicitud obtendrás tu dinero en pocas horas',
      imageTitle: 'Obtén tu dinero',
      description: 'Confirma el anticipo y recibe tu dinero en poco tiempo',
      image: '/images/step3.webp',
    },
  ],
};

export default fingoStepsData;
